// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "details[open]+.annotation-summary[data-v-5b351ac4],details[open]>summary>.open-detail[data-v-5b351ac4]{display:none}details[open]>summary>.close-detail[data-v-5b351ac4]{display:inline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
